import mapboxgl from 'mapbox-gl';

export function createMap(options) {
    mapboxgl.accessToken = mapboxSettings.accessToken;

    return new mapboxgl.Map({
        style: 'mapbox://styles/eventconnectors/clwuexstn015i01qx6afg97vt',
        ...options
    });
}

export { mapboxgl };